import { getUnpaginatedAll } from '../../../helpers/getUnpaginatedAll'
import { ecbrRequest } from '../../request/ecbrRequest'

export const brands = {
  getAll: async (params) => ecbrRequest.get('/brands', { params }),
  create: async (brand) => ecbrRequest.post('/brands', brand),
  getByCompanyId: async (companyId, params = {}) =>
    ecbrRequest.get(`/brands/company/${companyId}`, { params }),
  getActualCompanyBrands: async (params = {}) =>
    ecbrRequest.get('/company/brands', { params }),
  getAllActualCompanyBrands: async (params = {}) => {
    return {
      data: await getUnpaginatedAll(
        (pagination) =>
          ecbrRequest.get('/company/brands', {
            params: { ...params, ...pagination }
          }),
        params.page,
        params.take
      )
    }
  },
  existsByUrlWebsite: async (url) =>
    ecbrRequest.get(`/brands/exists?key=urlWebsite&value=${url}`)
}
